export function isValidHexValue(hex: string): boolean {
    const validHex = /^#([a-fA-F0-9]{6}|[a-fA-F0-9]{3})$/;

    return validHex.test(hex);
}
